import { styled } from "@stitches/react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import PlayButton from "./PlayPauseButton";

const SelectThemeContainer = styled("div", {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  fontSize: "0.9rem",
  background: "rgba(255,255,255,0.05)",
  fontWeight: "bold",
  justifyContent: "center",
});

const DropContent = styled(DropdownMenu.Content, {
  padding: 12,
  background: "var(--bg)",
});

const DropItem = styled(DropdownMenu.Item, {
  padding: 12,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "0.9rem",
  color: "#fff",
  cursor: "pointer",
});

function SelectTheme({
  options,
  activeOption,
  changeTheme,
  paused,
  toogleExperience,
}) {
  return (
    <DropdownMenu.Root
      style={{
        width: "100%",
        marginBottom: 30,
      }}
    >
      <DropContent disableOutsideScroll={false}>
        {options
          .filter((e) => e.key !== activeOption)
          .map((option) => (
            <DropItem
              onSelect={() => {
                changeTheme(option.key);
              }}
            >
              {option.label}
            </DropItem>
          ))}
      </DropContent>

      <SelectThemeContainer>
        <DropdownMenu.Trigger
          as="a"
          style={{
            cursor: "pointer",
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          {options.find((e) => e.key === activeOption).label}{" "}
          <span style={{ marginLeft: 8, fontSize: 18 }}>▾</span>
        </DropdownMenu.Trigger>

        <PlayButton
          paused={paused}
          onClick={() => {
            toogleExperience();
          }}
        />
      </SelectThemeContainer>
    </DropdownMenu.Root>
  );
}

export default SelectTheme;
